import newFunnelLight from "../../../../contents/images/docs/user-guides/funnels/new-funnel-light-mode.mp4";
import newFunnelDark from "../../../../contents/images/docs/user-guides/funnels/new-funnel-dark-mode.mp4";
import funnelStepsLight from "../../../../contents/images/docs/user-guides/funnels/funnel-steps-light-mode.png";
import funnelStepsDark from "../../../../contents/images/docs/user-guides/funnels/funnel-steps-dark-mode.png";
import globalFiltersLight from "../../../../contents/images/docs/user-guides/funnels/global-filters-light-mode.png";
import globalFiltersDark from "../../../../contents/images/docs/user-guides/funnels/global-filters-dark-mode.png";
import setFunnelTimeRangeLight from "../../../../contents/images/docs/user-guides/funnels/set-funnel-time-range-light-mode.png";
import setFunnelTimeRangeDark from "../../../../contents/images/docs/user-guides/funnels/set-funnel-time-range-dark-mode.png";
import saveAFunnelLight from "../../../../contents/images/docs/user-guides/funnels/save-a-funnel-light-mode.mp4";
import saveAFunnelDark from "../../../../contents/images/docs/user-guides/funnels/save-a-funnel-dark-mode.mp4";
import personsModalLight from "../../../../contents/images/docs/user-guides/funnels/persons-modal-light-mode.png";
import personsModalDark from "../../../../contents/images/docs/user-guides/funnels/persons-modal-dark-mode.png";
import identifyingLight from "../../../../contents/images/docs/user-guides/funnels/identifying-drop-offs-light-mode.png";
import identifyingDark from "../../../../contents/images/docs/user-guides/funnels/identifying-drop-offs-dark-mode.png";
import switchToRelativeLight from "../../../../contents/images/docs/user-guides/funnels/switch-to-relative-drop-off-light-mode.png";
import switchToRelativeDark from "../../../../contents/images/docs/user-guides/funnels/switch-to-relative-drop-off-dark-mode.png";
import averageTimeToConvertLight from "../../../../contents/images/docs/user-guides/funnels/average-time-to-convert-light-mode.png";
import averageTimeToConvertDark from "../../../../contents/images/docs/user-guides/funnels/average-time-to-convert-dark-mode.png";
import distributionHistogramLight from "../../../../contents/images/docs/user-guides/funnels/distribution-histogram-time-to-convert-light-mode.png";
import distributionHistogramDark from "../../../../contents/images/docs/user-guides/funnels/distribution-histogram-time-to-convert-dark-mode.png";
import granularConversionLight from "../../../../contents/images/docs/user-guides/funnels/granular-conversion-time-distribution-light-mode.png";
import granularConversionDark from "../../../../contents/images/docs/user-guides/funnels/granular-conversion-time-distribution-dark-mode.png";
import breakdownByOSLight from "../../../../contents/images/docs/user-guides/funnels/breakdown-by-operating-system-light-mode.png";
import breakdownByOSDark from "../../../../contents/images/docs/user-guides/funnels/breakdown-by-operating-system-dark-mode.png";
import funnelStepBreakdownLight from "../../../../contents/images/docs/user-guides/funnels/funnel-steps-breakdown-light-mode.png";
import funnelStepBreakdownDark from "../../../../contents/images/docs/user-guides/funnels/funnel-steps-breakdown-dark-mode.png";
import converstionOverTimeLight from "../../../../contents/images/docs/user-guides/funnels/conversion-over-time-using-trends-light-mode.png";
import converstionOverTimeDark from "../../../../contents/images/docs/user-guides/funnels/conversion-over-time-using-trends-dark-mode.png";
import * as React from 'react';
export default {
  newFunnelLight,
  newFunnelDark,
  funnelStepsLight,
  funnelStepsDark,
  globalFiltersLight,
  globalFiltersDark,
  setFunnelTimeRangeLight,
  setFunnelTimeRangeDark,
  saveAFunnelLight,
  saveAFunnelDark,
  personsModalLight,
  personsModalDark,
  identifyingLight,
  identifyingDark,
  switchToRelativeLight,
  switchToRelativeDark,
  averageTimeToConvertLight,
  averageTimeToConvertDark,
  distributionHistogramLight,
  distributionHistogramDark,
  granularConversionLight,
  granularConversionDark,
  breakdownByOSLight,
  breakdownByOSDark,
  funnelStepBreakdownLight,
  funnelStepBreakdownDark,
  converstionOverTimeLight,
  converstionOverTimeDark,
  React
};